<div class="background-color" style="min-height: 300px;">
    <div style="z-index:2;" *ngIf="!agencyService.isLoading">
        <ts-agency-submenu [agency]="agencyService.agency"></ts-agency-submenu>
        <router-outlet *ngIf="agencyService.agency"></router-outlet>
        <ts-agency-footer [agency]="agencyService.agency"></ts-agency-footer>
        <ts-agency-style [settings]="agencyService.agency.settings"></ts-agency-style>
    </div>
</div>
